<template>
  <div
    :class="messageClass"
    class="p-3 text-center"
    role="alert"
    v-if="message"
  >
    <div
      v-if="message === 'Error: Not Found' || message.startsWith('Not Found')"
    >
      <h4>404: Location not found</h4>
    </div>
    <div v-else-if="message === 'JWT Token not found'">
      <h4>
        You must be logged in & a member of this project to view this location
      </h4>
    </div>
    <div v-else-if="message.startsWith('Failed to fetch')">
      Network Error. Try again later
    </div>
    <div v-if="message.includes('is still referenced from table')">
      Remove all observations to delete this location.
    </div>
    <div v-else-if="message.includes('deleted successfully.')">
      Location deleted successfully
    </div>
    <div v-else class="">Error: {{ message }}</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LocationMessage",
  computed: {
    ...mapGetters({
      message: "location/message",
      messageType: "location/messageType",
    }),
    messageClass() {
      if (this.messageType === null) {
        return "bg-light text-dark";
      }
      if (this.messageType === "error") {
        return "bg-danger text-light";
      }
      if (this.messageType === "success") {
        return "bg-tertiary text-light";
      }
    },
  },
};
</script>
<style lang="css" scoped></style>
